import React from 'react';
import { Helmet } from 'react-helmet';
import Seo from './Seo';

const SeoPage = () => (
  <>
    <Helmet>
      <title>SEO Services | MilaajBrandset</title>
      <meta
        name="description"
        content="Boost your online visibility with MilaajBrandset's SEO services. Improve your website's search engine ranking and drive more traffic to your site."
      />
      <meta
        name="keywords"
        content="MilaajBrandset, SEO services, search engine optimization, website ranking, online visibility"
      />
      <meta property="og:title" content="SEO Services | MilaajBrandset" />
      <meta
        property="og:description"
        content="Boost your online visibility with MilaajBrandset's SEO services. Improve your website's search engine ranking and drive more traffic to your site."
      />
    </Helmet>
    <Seo />
  </>
);

export default SeoPage;